import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../shared';

/**
 * Encounter API - Base definition
 *
 * This is the base API slice for the Encounter service.
 * Endpoints are split into separate files and injected using injectEndpoints.
 *
 * @see encounterEndpoints.ts - Encounter CRUD operations
 * @see scheduleEndpoints.ts - Schedule queries and exports
 */
export const encounterApi = createApi({
  reducerPath: 'encounterApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.encounters),
  tagTypes: ['Encounter', 'Encounters', 'MedicalRecordsQueue', 'StaffCaseRequestQueue', 'StaffCaseRequest', 'SurgeryBoard', 'BlockSchedule'],
  endpoints: () => ({}),
});

